import { type AxiosResponse } from 'axios'
import type { AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import { type IResponseConversation } from 'entities/Conversation/api/types'
import { type IResponseInbox } from 'entities/Inbox/api/types'
import { type IResponseOrganization } from 'entities/Organization/api/types'
import { type IResponseUser } from 'entities/Users/api/types'
import { type IParamsConversationsTransfer } from './types'

class Api {
  getActiveOrganizations(options?: AxiosOptions): Promise<AxiosResponse<IResponseOrganization[]>> {
    return baseApi.get('agency/clients/active', {
      params: {
        all: true,
      },
      ...options,
    })
  }

  getTeamsByOrganizationId(
    organizationId: number | string
  ): Promise<AxiosResponse<IResponseInbox[]>> {
    return baseApi.get('conversations/transfer/teams/list', {
      params: { organization_id: organizationId },
    })
  }

  getMembersByInboxId(inboxId: number | string): Promise<AxiosResponse<IResponseUser[]>> {
    return baseApi.get('conversations/transfer/members/list', { params: { team_id: inboxId } })
  }

  transferConversations(
    data: IParamsConversationsTransfer
  ): Promise<AxiosResponse<IResponseConversation[]>> {
    return baseApi.post('conversations/transfer', data)
  }
}
export const TransferApi = new Api()
